import DefaultValidation from "@/services/validations/DefaultValidation";
import Message from '@/models/Message';

export default class TipoVeiculoValidation extends DefaultValidation{

  constructor(msgs) {
    super(msgs);
  }

  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (!model.descricao) {
      refs.descricaoInput.focusedOut = true;
      validated = false;
      this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
    }

    if (!model.icone) {
      refs.iconeInput.focusedOut = true;
      validated = false;
      this.showMessage(new Message("alert", 'msg-campos-obrigatorios', true));
    }
    
    return validated;

  }
}